import { Row } from "react-bootstrap";
import loadMultipleFiles from "../util/loadMultipleFiles";

//renders header, static throughout all routes.
function Header() {
  const headerAssets = loadMultipleFiles("header");

  return (
    <header name="header" id="header" className="contain">
      <Row className="header-banner contain">
        <div className="header-image-container contain">
          <div
            className="header-image contain"
            style={{ backgroundImage: "url(" + headerAssets.banner + ")" }}
          >
            <h1
              aria-hidden="true"
              className="contain"
              style={{ position: "static", opacity: "0" }}
            >
              {headerAssets.text.h1}
            </h1>
            <p
              aria-hidden="true"
              className="contain"
              style={{ position: "static", opacity: "0", margin: 0 }}
            >
              {headerAssets.text.p}
            </p>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1 name="site title" className="contain">
            {headerAssets.text.h1}
          </h1>
          <p style={{ margin: 0 }} className="contain">
            {headerAssets.text.p}
          </p>
        </div>
      </Row>
    </header>
  );
}

export default Header;
